var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"science-detail"},[_c('div',{staticClass:"phone"},[_c('iframe',{staticClass:"detailIframe",attrs:{"id":"detailIframe","name":"detailIframe","src":_vm.url+'/#/science/picture-word?id='+_vm.id+'&os='+_vm.os}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e394eff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ScienceDetail.vue
// module id = null
// module chunks = 